import { apiService } from './axiosAuth'

export const uploadFile = (data, url, uploadConfig) => apiService.post(url, data, uploadConfig);
export const deleteFile = (url, uploadConfig) => apiService.delete(url, uploadConfig);